import menuStyle from "../templates/Menu.style"; // import menuHzeroStyle from '../templates-hzero/Menu.style';

var menuData = {
  name: 'menu',
  data: [{
    fontSize: 14,
    fontColor: '#0F1358',
    arrowWidth: 8,
    arrowHeight: 8,
    arrowRightDistance: 16,
    arrowColor: '#333333'
  }],
  // onlyTemplate: [menuStyle, menuHzeroStyle],
  onlyTemplate: menuStyle
};
export default menuData;